// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
//import wixStoresBackend from 'wix-stores-backend'

$w.onReady(function () {
	//var QuantityInCart =
	// $w('#CartValue').text = wixStoresBackend.getCurrentCart().;
	// var cart = wixStoresBackend.getCurrentCart();
	// wixStoresBackend.getCurrentCart().valueOf()
 
 const today = new Date();   
   const options = {    
    year: "numeric"
};

var thisYear =  today.toLocaleDateString("en-US", options);    
    //var  CopyrightYearsValue = "Babyco LTD - בייביקו בע""מ";
	
    //CopyrightYearsValue=CopyrightYearsValue + "1994-" + thisYear + "©";
  $w('#text12').text =  "כל הזכויות שמורות לחברת בייביקו בע\"מ" + " 1994-" + thisYear + " Babyco LTD ©";

	//TODO: write your page related code here...
		if(wixWindow.formFactor === "Mobile"){
  $w("#MyMobileShoppingCart").show();  
 }

}
);